import Heading from "./component";
export default Heading;
